<template>
<div class="chapter">
<div class="inner_page">
<div class="" data-pdf-bookmark="Part II. Meet the Team . . ." data-type="part" epub:type="part" id="d1e1155"><h1 class="PartTitlept"><span href="#/toc01" title="Link target outside of Sample">Meet the Team . . .</span></h1><h1 class="PartTitlept"><span href="#/toc01" title="Link target outside of Sample">TROUBLE COMES IN SPADES.</span></h1><figure class="Illustrationholderill customimage"><div class="figure"><img alt="Spade.png" src="Spade.jpg"/></div></figure>
<p class="Head-Level-1h1">Meet the Spades . . .</p><blockquote>
<p class="Extract-NoIndentext1">That girl CLEO gets around. Pop, she’s here, pop, she’s there, pop, she’s just behind you. Watch out for</p>
<p class="Extract-NoIndentext1">CLEOPATRA!</p>
<p class="Extract-NoIndentext1">Cleonida Simpson</p>
<p class="Extract-NoIndentext1">Montgomery, Alabama</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">RACHEL has the bestest collection of stuffies anywhere. They’re all so soft and cute and cuddly, just like</p>
<p class="Extract-NoIndentext1">DRAGON HUNTRESS!</p>
<p class="Extract-NoIndentext1">Rachel Weinstein</p>
<p class="Extract-NoIndentext1">Bayonne, New Jersey</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">An iron man from the Iron Range, WALLY has steel in his fists and a furnace for a heart. Rust never sleeps, and neither does</p>
<p class="Extract-NoIndentext1">RUSTBELT!</p>
<p class="Extract-NoIndentext1">Wally “Rusty” Gunderson</p>
<p class="Extract-NoIndentext1">Mountain Iron, Minnesota</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">THE KING is the mystery man from down along the border. Where is he from? What can he do? Who dares to look beneath the mask of</p>
<p class="Extract-NoIndentext1">KING COBALT!</p>
<p class="Extract-NoIndentext1">name unknown</p>
<p class="Extract-NoIndentext1">Somewhere in California</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">There’s never a loser when ROSA deals the cards. Diva or demon, snake or lion, even death itself, they’re all in the hands of</p>
<p class="Extract-NoIndentext1">ROSA LOTERIA!</p>
<p class="Extract-NoIndentext1">Guadelupe Maria del Rosario Garza</p>
<p class="Extract-NoIndentext1">East Los Angeles, California</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">ALI likes to dust things up. The girl has got a little devil in her. From the land of Elvis and the Living Gods comes</p>
<p class="Extract-NoIndentext1">SIMOON!</p>
<p class="Extract-NoIndentext1">Aliyah Malik</p>
<p class="Extract-NoIndentext1">Las Vegas, Nevada</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">JOHN burns bright by day and night in half a hundred hues. Let those who hide in darkness cower, and beware the light of</p>
<p class="Extract-NoIndentext1">THE CANDLE!</p>
<p class="Extract-NoIndentext1">John Montano</p>
<p class="Extract-NoIndentext1">Durango, Colorado</p></blockquote></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?13791039